import { gql } from '@apollo/client';

export const ADD_FRAMEWORKRESULTS_TO_PROGRAMME = gql`
  mutation addFrameworkResultsToProgramme($input: AddFrameworkResultsToProgrammeInput!) {
    intervention: addFrameworkResultsToProgramme(input: $input) {
      id
    }
  }
`;
